import { render, staticRenderFns } from "./PlatformOrderCreation.vue?vue&type=template&id=1630b53a&scoped=true&"
import script from "./PlatformOrderCreation.vue?vue&type=script&lang=js&"
export * from "./PlatformOrderCreation.vue?vue&type=script&lang=js&"
import style0 from "./PlatformOrderCreation.vue?vue&type=style&index=0&id=1630b53a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1630b53a",
  null
  
)

export default component.exports